export var app = {
  namespaced: true,
  state: {
    selectAppId: "",
    isAdd: "",
    // 用于判断是否在添加渠道
    isChangeAppInfo: 0 // 用于监听是否有保存/修改渠道信息，重新加载渠道下拉列表
  },

  mutations: {
    setSelectAppId: function setSelectAppId(state, selectAppId) {
      state.selectAppId = selectAppId;
    },
    setIsAdd: function setIsAdd(state, IsAdd) {
      state.isAdd = IsAdd;
    },
    setIsChangeAppInfo: function setIsChangeAppInfo(state, isChangeAppInfo) {
      state.isChangeAppInfo = isChangeAppInfo;
    }
  },
  actions: {},
  getters: {
    selectAppId: function selectAppId(state) {
      return state.selectAppId;
    },
    isAdd: function isAdd(state) {
      return state.isAdd;
    },
    isChangeAppInfo: function isChangeAppInfo(state) {
      return state.isChangeAppInfo;
    }
  }
};